import { Skeleton, Table, Text } from "@chakra-ui/react";
import React from "react";

export const UserListSkeleton = () => {
  return (
    <Table.ScrollArea
      borderWidth="1px"
      rounded="md"
      height="70vh"
      width="100%"
    >
      <Table.Root interactive variant="outline" stickyHeader>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader width="20%" textAlign="center">
              Full Name
            </Table.ColumnHeader>
            <Table.ColumnHeader width="20%" textAlign="center">
              Balance
            </Table.ColumnHeader>
            <Table.ColumnHeader width="20%" textAlign="center">
              Account No.
            </Table.ColumnHeader>
            <Table.ColumnHeader width="20%" textAlign="center">
              Mobile
            </Table.ColumnHeader>
            <Table.ColumnHeader width="20%" textAlign="center">
              Actions
            </Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Array.from({ length: 10 })?.map((_, rowIndex) => (
            <Table.Row key={rowIndex}>
              {Array.from({ length: 5 })?.map((_, colIndex) => (
                <Table.Cell
                  key={colIndex}
                  textAlign="center"
                  fontSize="xs"
                  padding="1rem"
                >
                  <Skeleton asChild loading={true} width="100%" variant="shine">
                    <Text>T</Text>
                  </Skeleton>
                </Table.Cell>
              ))}
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Table.ScrollArea>
  );
};
